import { Customer } from "gen/customer/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useSearchJobs } from "features/api/search"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

interface UseJobFilterProps
  extends Partial<Pick<UseWebFilterProps<unknown>, "persistInUrl" | "key">> {
  customerId?: PBUUID
}

export function useJobFilter({
  customerId,
  persistInUrl = true,
  key = "job",
}: UseJobFilterProps = {}) {
  const { results, setQuery, loadNext } = useSearchJobs({
    customerIds: customerId ? [customerId] : [],
  })

  const jobs = useMemo(() => {
    const res: Customer[] = []
    for (const { job } of results) {
      if (!job) continue
      res.push(job)
    }
    return res
  }, [results])

  const { filter, selected: selectedJobIds } = useIdFilter({
    key,
    label: "Job",
    values: jobs,
    labelExtractor: (job) => job.name,
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    onLoadMore: loadNext,
    useFilter: (props) => {
      return useWebFilter({
        ...props,
        persistInUrl,
      })
    },
  })

  return { filter, selectedJobIds }
}
